import { render, staticRenderFns } from "./PassportEvidence.vue?vue&type=template&id=221c0a58&scoped=true"
import script from "./PassportEvidence.vue?vue&type=script&lang=js"
export * from "./PassportEvidence.vue?vue&type=script&lang=js"
import style0 from "./PassportEvidence.vue?vue&type=style&index=0&id=221c0a58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221c0a58",
  null
  
)

export default component.exports